import { useCallback, useEffect, useRef, useState } from "react";
import CrearButton from "./ClearButton";

export const MobilePopupDropdown = ({
  title,
  isOpen,
  onToggle,
  iconSlot,
  children
}) => {
  const contentRef = useRef();
  const [contentHeight, setContentHeight] = useState(0);

  const onButtonClick = useCallback(() => {
    onToggle();
  }, [onToggle]);

  useEffect(() => {
    if (isOpen === true) {
      setContentHeight(contentRef.current.scrollHeight);
    } else {
      setContentHeight(0);
    }
  }, [contentRef, isOpen]);

  return (
    <div className={`mobile-popup-dropdown ${isOpen ? 'opened' : ''}`}>
      <div className="mobile-popup-dropdown-button h-padding" onClick={onButtonClick}>
        <span className="mobile-popup-dropdown-button__title">{title}</span>
        {!iconSlot ? <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none" className="mobile-popup-dropdown-button__icon">
          <path d="M7.5 12L3.60288 5.25L11.3971 5.25L7.5 12Z" fill="#FF9900" />
        </svg> : iconSlot}
      </div>
      <div className="mobile-popup-dropdown__content" ref={contentRef} style={{ height: contentHeight }}>
        {children}
      </div>
    </div>
  )
}

const MobilePopup = ({
  title,
  onCloseCallback,
  children
}) => {
  const [show, setShow] = useState(false);
  const timeoutRefs = useRef({
    first: null,
    second: null
  });

  const clearAllTimeouts = () => {
    if (timeoutRefs.current.first) {
      clearTimeout(timeoutRefs.current.first);
    }
    if (timeoutRefs.current.second) {
      clearTimeout(timeoutRefs.current.second);
    }
    timeoutRefs.current.first = null;
    timeoutRefs.current.second = null;
  };

  const onClose = useCallback(() => {
    clearAllTimeouts();

    timeoutRefs.current.first = setTimeout(() => {
      setShow(false);
    }, 50);

    timeoutRefs.current.second = setTimeout(() => {
      onCloseCallback();
    }, 300);

    return clearAllTimeouts;
  }, [onCloseCallback]);

  useEffect(() => {
    clearAllTimeouts();

    timeoutRefs.current.first = setTimeout(() => {
      setShow(true);
    }, 100);

    return clearAllTimeouts;
  }, []);

  return (
    <div className={`mobile-popup__wrapper ${show ? 'show' : ''}`}>
      <div className="mobile-popup__background" onClick={onClose}></div>
      <div className="mobile-popup">
        <div className="mobile-popup__scroll">
          <div className="mobile-popup__title-outer h-padding">
            <h2 className="games-catalog__subtitle">{title}</h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" onClick={onClose}>
              <path d="M10.733 32.334L8.33301 29.934L17.933 20.334L8.33301 10.734L10.733 8.33398L20.333 17.934L29.933 8.33398L32.333 10.734L22.733 20.334L32.333 29.934L29.933 32.334L20.333 22.734L10.733 32.334Z" fill="#FF4E28" />
            </svg>
          </div>
          {children}
          <CrearButton onClickCallback={onClose} />
        </div>
      </div>
    </div>
  )
}

export default MobilePopup;